import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vertical-menu',
  templateUrl: './vertical-menu.component.html'
})
export class VerticalMenuComponent implements OnInit {

  @Input() menus: any;
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/app/core/components/vertical-menu/vertical-menu.component.ts